export const INSPECTION_ORIGIN_KEY = "inspection_origin";
